import { AuthService } from '#services/shared';
import { Injectable } from '@angular/core';
import { BroadcastService, MsalService } from '@azure/msal-angular';


import { Utility } from '#services/shared/utility';
import { Subject } from 'rxjs';


@Injectable()
export class Bootstrap {

  private subject$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private authSvc: AuthService,
    private msalService: MsalService,
    private broadcastService: BroadcastService) {

    this.broadcastService.subscribe('msal:loginSuccess', () => {
      this.subject$.next(true);
      this.subject$.complete();
    });
  }

  isB2C() {
    return window.location.pathname === '/b2c';
  }

  init() {
    if (this.isB2C() && Utility.validateEnvironment()) {
      return Promise.resolve();
    }

    if (this.authSvc.isMsalAuthenticated()) {
      const redirectUri = this.getLastRedirectedUri();
      if (redirectUri !== null) {
        this.clearLastRedirectUri();
        this.goTo(redirectUri);
        return;
      }

      return this.authSvc.loadUserInfo().catch(console.error);
    }

    if (this.authSvc.isb2cLoged()) {
      return this.authSvc.loadUserInfo().catch(console.error);
    }

    if (!this.isHomePage()) {
      this.saveLastRedirectUri();
      this.goTo('/');
      return;
    }

    this.msalService.handleRedirectCallback((authError) => {
      if (authError) {
        this.subject$.error(authError);
      } else {
        this.subject$.next(true);
        this.subject$.complete();
      }
    });

    this.msalService.loginRedirect();

    return this.subject$.toPromise()
      .then(() => this.authSvc.loadUserInfo().catch(console.error));
  }
  private clearLastRedirectUri() {
    localStorage.removeItem('redirectUri');
  }
  isHomePage() {
    return window.location.pathname === '/';
  }
  saveLastRedirectUri(): void {
    localStorage.setItem('redirectUri', window.location.pathname);
  }
  getLastRedirectedUri() {
    return localStorage.getItem('redirectUri');
  }
  goTo(redirectUri: string) {
    location.href = redirectUri;
  }
}

export const initializeApp = (bootstrap: Bootstrap) => () => bootstrap.init();
